import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";

const api = pythonVmInstance;

// Returns API
export const getUnifiedReturns = (filters = {}) => {
	const params = new URLSearchParams();
	if (filters.date_from) params.append("date_from", filters.date_from);
	if (filters.date_to) params.append("date_to", filters.date_to);
	if (filters.status) params.append("status", filters.status);
	if (filters.return_type) params.append("return_type", filters.return_type);
	if (filters.filter_options) params.append("filter_options", filters.filter_options);

	return api.get(`/returns/unified?${params.toString()}`);
};

export const downloadUnifiedReturns = (filters = {}) => {
	const params = new URLSearchParams();
	if (filters.date_from) params.append("date_from", filters.date_from);
	if (filters.date_to) params.append("date_to", filters.date_to);
	if (filters.status) params.append("status", filters.status);
	if (filters.return_type) params.append("return_type", filters.return_type);

	return api.get(`/returns/unified/download?${params.toString()}`, {
		responseType: 'blob'
	});
};

export default api;
